/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useMemo, useState } from "react";

import Footer from "../Layout/Footer";
import Header from "../Layout/Header";
import { CommonPageData } from "../../styles/common.style";
import { useNavigate, useLocation } from "react-router-dom";
import { FadeLoader } from "react-spinners";
import { variationCorrectionMap } from "../../utils/constants";
import { assessmentDiscrepancyCheck } from "../../dao/assessmement";
import { FaArrowRight } from "react-icons/fa";

const FinishAssessment = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [pollResult, setPollResult] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const ankleKeywords = [
    "Both Ankles Restriction",
    "Left Ankle Restriction",
    "Right Ankle Restriction",
  ];
  const normalize = (str) => str.toLowerCase().trim();

  const applyDisplayTransform = (variation) => {
    if (variation === "Both Pronations") return "Ankle Pronation (both sides)";
    if (variation === "Both Knees In") return "Knees In";
    return variation;
  };

  const correctedVariations = (pollResult?.bodyTypeVariations ?? [])
    .map((variation) => {
      const norm = normalize(variation);
      return variationCorrectionMap[norm] || variation;
    })
    .filter((v) => !ankleKeywords.includes(v))
    .map(applyDisplayTransform);

  const user = useMemo(() => {
    try {
      const userData = localStorage.getItem("user");
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      console.error("Error parsing user data:", error);
      return null;
    }
  }, []);

  useEffect(() => {
    let isMounted = true;

    const getAllPrograms = async () => {
      const MAX_POLLS = 30;
      const POLL_DELAY_MS = 2000;

      try {
        for (let attempt = 0; attempt < MAX_POLLS; attempt++) {
          const response = await assessmentDiscrepancyCheck();
          const result = response?.data?.data;

          if (!result) break;

          const { discrepancyStatus, bodyTypeStatus } = result;

          if (discrepancyStatus === "needs_review") {
            if (isMounted) setPollResult(result);
            return;
          }

          if (discrepancyStatus === "none" && bodyTypeStatus === "ready") {
            if (!result?.programAssignment?.mainProgram?.programName) {
              if (isMounted)
                setError("Something went wrong. Please contact support.");
              return;
            }
            if (isMounted) setPollResult(result);
            return;
          }

          if (attempt < MAX_POLLS - 1) {
            await new Promise((resolve) => setTimeout(resolve, POLL_DELAY_MS));
          }
        }

        // Exhausted all attempts without a conclusive result
        if (isMounted)
          setError("Timed out waiting for results. Please try again.");
      } catch (err) {
        console.error("Polling failed:", err);
        if (isMounted) setError("Something went wrong. Please try again.");
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    getAllPrograms();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleFinish = () => {
    navigate("/my-programs");
  };

  const handleRetry = () => {
    setError(null);
    setIsLoading(true);
    navigate(0); // simple page reload to restart polling
  };

  if (isLoading) {
    return (
      <>
        <Header />
        <CommonPageData>
          <div
            className="loading-container"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
            }}
          >
            <FadeLoader color="#FB1417" loading />
          </div>
        </CommonPageData>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header />
        <CommonPageData>
          <div className="common-banner-block">
            <div className="main-banner">
              <img src="/images/banner-common-block.png" alt="img" />
            </div>
            <div className="container">
              <div className="common-banner-block-inner">
                <h1>Submission Failed</h1>
              </div>
            </div>
          </div>

          <div className="assesment-info">
            <div className="container">
              <div className="assesment-info-finised">
                <p style={{ color: "#FB1417", marginBottom: "1rem" }}>
                  {error}
                </p>
                <div className="btn-block-assesment">
                  <button
                    onClick={handleRetry}
                    className="theme-common-btn-big mt-5"
                  >
                    Retry
                    <FaArrowRight className="ms-2" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </CommonPageData>
        <Footer />
      </>
    );
  }

  return (
    <div>
      <Header />

      <CommonPageData>
        <div className="common-banner-block">
          <div className="main-banner">
            <img src="/images/banner-common-block.png" alt="img" />
          </div>

          <div className="container">
            <div className="common-banner-block-inner">
              {pollResult?.discrepancyStatus === "none" && (
                <h1>Assessment Complete</h1>
              )}
              {pollResult?.discrepancyStatus === "needs_review" && (
                <h1>Assessment Under Review</h1>
              )}
            </div>
          </div>
        </div>

        <div
          className="assesment-info"
          style={
            pollResult?.discrepancyStatus === "none"
              ? {
                  minHeight: "calc(100vh - 210px)",
                  display: "flex",
                  flexDirection: "column",
                  padding: "48px 0",
                  boxSizing: "border-box",
                }
              : undefined
          }
        >
          <div
            className="container"
            style={
              pollResult?.discrepancyStatus === "none"
                ? { flex: 1, display: "flex", flexDirection: "column" }
                : undefined
            }
          >
            {pollResult?.discrepancyStatus === "none" && (
              <div
                className="assesment-info-finised"
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h2 style={{ fontWeight: 700 }}>Great Work!</h2>

                <p
                  className="mb-3"
                  style={{
                    color: "#404040",
                    fontSize: "1.70rem",
                    fontWeight: 600,
                    lineHeight: 1.6,
                  }}
                >
                  We've analyzed your movement and assigned a personalized
                  <br />
                  12-week program to correct the imbalances we identified.
                </p>

                <div
                  style={{
                    background: "#fff",
                    borderRadius: 64,
                    border: "3px solid #e6e6e6",
                    padding: "32px 28px",
                    margin: "24px auto",
                    width: 680,
                    textAlign: "center",
                    color: "#222",
                    boxShadow:
                      "-6px -6px 8px rgba(0, 0, 0, 0.08), inset -3px -3px 8px rgba(0, 0, 0, 0.06)",
                  }}
                >
                  <div
                    style={{
                      fontWeight: 700,
                      fontSize: "1.70rem",
                      textTransform: "uppercase",
                      letterSpacing: 1,
                      marginBottom: 12,
                      color: "#000",
                    }}
                  >
                    Main Program
                  </div>
                  <div
                    style={{
                      color: "#C00000",
                      fontWeight: 700,
                      fontSize: "2.25rem",
                      marginBottom: 48,
                    }}
                  >
                    {(() => {
                      const name =
                        pollResult?.programAssignment?.mainProgram?.programName;
                      if (name) return name.replace(/^\s*BODY TYPE:\s*/i, "");
                      if (pollResult?.discrepancyStatus === "needs_review")
                        return "Your assessment is being reviewed...";
                      return null;
                    })()}
                  </div>

                  {!!correctedVariations.length && (
                    <div style={{ display: "inline-block", textAlign: "left" }}>
                      <div
                        style={{
                          fontWeight: 700,
                          fontSize: "1.70rem",
                          textTransform: "uppercase",
                          letterSpacing: 1,
                          marginBottom: 12,
                          color: "#404040",
                        }}
                      >
                        Other Imbalances
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 6,
                        }}
                      >
                        {correctedVariations.map((variation, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "baseline",
                              gap: 6,
                            }}
                          >
                            <span style={{ color: "#C00000", fontWeight: 700 }}>
                              •
                            </span>
                            <span
                              style={{
                                color: "#C00000",
                                fontWeight: 600,
                                fontSize: "1.70rem",
                              }}
                            >
                              {variation}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <div
                  className="btn-block-assesment"
                  style={{ marginTop: "auto" }}
                >
                  <button
                    onClick={handleFinish}
                    className="theme-common-btn-big mt-5"
                  >
                    Program Page
                    <FaArrowRight className="ms-2" />
                  </button>
                </div>
              </div>
            )}

            {pollResult?.discrepancyStatus === "needs_review" && (
              <div className="assesment-info-finised">
                <p className="my-3">
                  Your assessment has been submitted and is being reviewed by a
                  specialist. Your personalized program will be assigned within
                  1–2 business days.
                </p>
                <p>You'll receive an email when your program is ready.</p>
              </div>
            )}
          </div>
        </div>
      </CommonPageData>
    </div>
  );
};

export default FinishAssessment;
